import {
  FaGlobe,
  FaMobileAlt,
  FaRobot,
  FaStore,
  FaBriefcase,
  FaPenNib,
  FaCogs,
  FaUserCircle,
  FaChartLine,
  FaHeadset,
  FaLightbulb,
  FaShoppingCart,
} from 'react-icons/fa';

export const servicesData = (t) => [
  {
    id: 1,
    icon: <FaGlobe size={85} color="#00e0ff" />,
    title: t('web_development_title'),
    description: t('web_development_description'),
    technologies: ['React', 'Vue', 'Node.js'],
    aiCollaboration: t('web_development_ai_collaboration'),
  },
  {
    id: 2,
    icon: <FaMobileAlt size={85} color="#00e0ff" />,
    title: t('mobile_app_development_title'),
    description: t('mobile_app_development_description'),
    technologies: ['React Native', 'Flutter', 'Kotlin'],
    aiCollaboration: t('mobile_app_development_ai_collaboration'),
  },
  {
    id: 3,
    icon: <FaRobot size={85} color="#00e0ff" />,
    title: t('automation_bots_title'),
    description: t('automation_bots_description'),
    technologies: ['Python', 'Node.js', 'RPA Tools'],
    aiCollaboration: t('automation_bots_ai_collaboration'),
  },
  {
    id: 4,
    icon: <FaStore size={85} color="#00e0ff" />,
    title: t('marketplace_development_title'),
    description: t('marketplace_development_description'),
    technologies: ['Laravel', 'React', 'MongoDB'],
    aiCollaboration: t('marketplace_development_ai_collaboration'),
  },
  {
    id: 5,
    icon: <FaBriefcase size={85} color="#00e0ff" />,
    title: t('crm_erp_solutions_title'),
    description: t('crm_erp_solutions_description'),
    technologies: ['MySQL', 'Vue.js', 'REST API'],
    aiCollaboration: t('crm_erp_solutions_ai_collaboration'),
  },
  {
    id: 6,
    icon: <FaPenNib size={85} color="#00e0ff" />,
    title: t('logo_design_animations_title'),
    description: t('logo_design_animations_description'),
    technologies: ['Figma', 'After Effects', 'Illustrator'],
    aiCollaboration: t('logo_design_animations_ai_collaboration'),
  },
  {
    id: 7,
    icon: <FaCogs size={85} color="#00e0ff" />,
    title: t('platform_development_title'),
    description: t('platform_development_description'),
    technologies: ['Node.js', 'React', 'Docker'],
    aiCollaboration: t('platform_development_ai_collaboration'),
  },
  {
    id: 8,
    icon: <FaUserCircle size={85} color="#00e0ff" />,
    title: t('portfolio_development_title'),
    description: t('portfolio_development_description'),
    technologies: ['React', 'Framer Motion', 'Tailwind CSS'],
    aiCollaboration: t('portfolio_development_ai_collaboration'),
  },
  {
    id: 9,
    icon: <FaChartLine size={85} color="#00e0ff" />,
    title: t('seo_optimization_title'),
    description: t('seo_optimization_description'),
    technologies: ['Analytics', 'Screaming Fr', 'Semrush'],
    aiCollaboration: t('seo_optimization_ai_collaboration'),
  },
  {
    id: 10,
    icon: <FaHeadset size={85} color="#00e0ff" />,
    title: t('technical_support_title'),
    description: t('technical_support_description'),
    technologies: ['Zendesk', 'LiveChat', 'Intercom'],
    aiCollaboration: t('technical_support_ai_collaboration'),
  },
  {
    id: 11,
    icon: <FaLightbulb size={85} color="#00e0ff" />,
    title: t('it_consulting_title'),
    description: t('it_consulting_description'),
    technologies: ['Analysis', 'Architecture', 'Audit'],
    aiCollaboration: t('it_consulting_ai_collaboration'),
  },
  {
    id: 12,
    icon: <FaShoppingCart size={85} color="#00e0ff" />,
    title: t('e_commerce_solutions_title'),
    description: t('e_commerce_solutions_description'),
    technologies: ['WooCommerce', 'React', 'Node.js'],
    aiCollaboration: t('e_commerce_solutions_ai_collaboration'),
  },
];
